import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as apiUtility from '../../config/APIUtils';

const BASE_URL_EMAIL_TO_EMPLOYER = "user/sendEmailEmp";
const BASE_URL_GET_ALLCOURSE_VERSIONS_USER_BASED = "course/getAllCourseVersion_forUser";

/***
 * 
 * @param {{}} [userData={}] 
 * @param {{}} [policyDataHistory={}] 
 * @param {[]} [courseHistory=[]] 
 * @param {{}} [trainingProviders={}] 
 * @param {string} [reportName=''] 
 * @param {string} [fileName=''] 
 * @param {boolean} [isEmail=false] 
 * @param {string} [reportType=1] 
 * 
 */
export async function PolicyPdfReport(userData = {}, history = {}, courseHistory = [], trainingProviders = {}, reportName = '', fileName = '', isEmail = false, reportType = 1) {
    try {

        const unit = "pt";
        const size = "A4";
        const orientation = "portrait";
        const compress = true;
        const fontSize = 8;
        const lineHeight = 1;
        const autoSize = false;
        const printHeaders = true;

        const doc = new jsPDF(orientation, unit, size, compress, fontSize, lineHeight, autoSize, printHeaders);

        const fullTitle = `Care Passport\n${reportName}`;
        const pageWidthForTitle = doc.internal.pageSize.getWidth();
        const titleLines = doc.splitTextToSize(fullTitle, pageWidthForTitle - 80);

        const lineColor = '#cccccc';
        const titleHeight = 55;
        const infoHeaderHeight = 150;
        const pageWidth = doc.internal.pageSize.getWidth() - 20;

        doc.setDrawColor(lineColor);
        //doc.setFillColor(0, 102, 153); // optional: fill for title bar background
        doc.rect(40, 20, pageWidth - 60, titleHeight);       // title area
        doc.rect(40, 20, pageWidth - 60, infoHeaderHeight);  // info area

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(15);
        doc.setTextColor(0, 102, 255); // blue[web:42][web:49]
        doc.text(titleLines, pageWidthForTitle / 2, 40, {
            align: 'center'
        });

        // ---------- User info table ----------
        let userBody = [{}];
        let userHeader = [{}];

        userHeader = [
            { first: 'Name : ' + userData.firstName + ' ' + userData.lastName, sec: ' ' }
        ];

        userBody = [
            { first: 'UserId : ' + userData.user_id, sec: 'Home : ' + userData.homeName },
            { first: 'Date Of Birth : ' + userData.dob, sec: 'Role : ' + userData.roleName },
            { first: 'Date : ' + new Date().toLocaleString(), sec: ' ' }
        ];

        autoTable(doc, {
            head: userHeader,
            body: userBody,
            styles: { font: 'helvetica', cellWidth: 'wrap' },
            startY: 80,
            theme: 'plain'
        });

        let totalHeight = titleHeight + infoHeaderHeight + 15;

        // Reset text color for rest of document
        doc.setTextColor(0, 0, 0);

        // ---------- Course report ----------
        if (reportType === 0 || reportType === 2) {
            const headers = [['Course Code', 'Title', 'Training Provider', 'Course Status', 'Expiry Date']];
            const tableData = [];

            const apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_GET_ALLCOURSE_VERSIONS_USER_BASED;
            apiRequest.data = {
                courses: courseHistory,
                userId: userData.user_id
            };

            await apiUtility.sendAPIDataPOST(apiRequest)
                .then((response) => {
                    for (const item of response.data) {
                        const courseVersion = [
                            item.crsId,
                            item.title,
                            item.orgIssued !== null && trainingProviders !== undefined
                                ? trainingProviders[parseInt(item.orgIssued)]
                                : '',
                            item.equivalentCrsStatus,
                            item.validity
                        ];
                        tableData.push(courseVersion);
                    }

                    const content = {
                        startY: doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 15 : totalHeight,
                        styles: { font: 'helvetica', cellWidth: 'auto', minCellWidth: 2 },
                        columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
                        headStyles: {
                            fillColor: [0, 102, 153],
                            halign: 'center'
                        },
                        margin: { top: 30 },
                        head: headers,
                        body: tableData,
                        theme: 'grid'
                    };

                    const courseTable = autoTable(doc, content);
                    const currentY = courseTable.finalY;

                    totalHeight = doc.lastAutoTable?.finalY
                        ? doc.lastAutoTable.finalY
                        : totalHeight + currentY;
                })
                .catch(error => {
                    return { code: 500, message: 'Error while processing courses.' };
                });
        }

        // ---------- Policy review ----------
        if (reportType === 1 || reportType === 2) {
            const headers = [['Doc Code', 'Title', 'Review Status', 'Expiry Date']];
            const tableData = [];

            for (const item of history) {
                const policyRecords = [
                    item.policyId,
                    item.title,
                    item.status !== 'Pending' ? item.status : '',
                    item.expiry_date !== '' ? new Date(item.expiry_date).toLocaleDateString() : ''
                ];
                tableData.push(policyRecords);
            }

            const content = {
                startY: doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 15 : totalHeight,
                styles: { font: 'helvetica', cellWidth: 'auto', minCellWidth: 2 },
                columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
                headStyles: {
                    fillColor: [0, 102, 153],
                    halign: 'center'
                },
                margin: { top: 30 },
                head: headers,
                body: tableData,
                theme: 'grid'
            };
            autoTable(doc, content);
        }

        // ---------- Verification report ----------
        if (reportType === 3) {
            const headers = [['Doc Code', 'Title', 'Date', 'Expiry Date', 'Status']];
            const tableData = [];

            for (const item of history) {
                const policyRecords = [
                    item.policyId,
                    item.title,
                    item.completion_date !== '' ? new Date(item.completion_date).toLocaleDateString() : '',
                    item.expiry_date !== '' ? new Date(item.expiry_date).toLocaleDateString() : '',
                    item.verification
                ];
                tableData.push(policyRecords);
            }

            const content = {
                startY: doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 15 : totalHeight,
                styles: { font: 'helvetica', cellWidth: 'auto', minCellWidth: 2 },
                columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
                headStyles: {
                    fillColor: [0, 102, 153],
                    halign: 'center'
                },
                margin: { top: 30 },
                head: headers,
                body: tableData,
                theme: 'grid'
            };
            autoTable(doc, content);
        }

        // ---------- Metadata ----------
        doc.setProperties({
            title: fullTitle,
            subject: 'Carepasport auto generated reports',
            author: 'Carepassport',
            keywords: 'generated, javascript, web 2.0, ajax',
            creator: 'Carepassport',
            bodyStyles: {
                color: '#cccccc'
            }
        });


        if (isEmail) {
            let blob = doc.output('blob');
            let data = new FormData();
            data.append("userId", userData.user_id);
            data.append("emailId", userData.empEmailId);
            data.append("subject", "Carepassport - " + reportName);
            data.append("reportName", fileName);
            data.append("file", blob);
            data.append("type", "PDF");
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_EMAIL_TO_EMPLOYER;
            apiRequest.data = data;
            apiUtility.sendAPIDataPOST(apiRequest)
                .then(response => {
                    return { code: 200, message: response.data };
                }).catch(error => {
                    return { code: 500, message: "Error while sending email" };
                });
        } else {
            doc.save(fileName !== '' ? fileName + ".pdf" : "Carepassport_" + userData.user_id + ".pdf");
            return { code: 200, message: 'File downloaded successfully' };
        }
    } catch (error) {
        console.log("error : ", error);
        return { code: 200, message: error };
    }
}